import React, { useState, useMemo } from "react";
import { AutoComplete, Input } from "antd";
import { SearchOutlined } from "@ant-design/icons";
import { useNavigate } from "react-router-dom";

const searchRoutes = {
  // Perfil de Usuario
  "Ver información de mi perfil": "/userprofile",
  "Ver información de mi usuario": "/userprofile",
  "Cambiar la foto del perfil": "/userprofile",
  "Cambiar la foto de mi usuario": "/userprofile",
  "Cambiar mi contraseña": "/userprofile",
  "Cambiar mi clave": "/userprofile",

  // Configuración del sistema
  "Configuraciones": "/settings",
  "Configuración del sistema": "/settings",
  "Opciones del sistema": "/settings",
  "Agregar un área": "/settings",
  "Crear un área": "/settings",
  "Modificar un área": "/settings",
  "Eliminar un área": "/settings",
  "Crear un nuevo tipo de dependencia": "/settings",
  "Agregar un nuevo tipo de dependencia": "/settings",
  "Modificar un tipo de dependencia": "/settings",
  "Eliminar un tipo de dependencia": "/settings",
  "Crear un nuevo atributo de dependencia": "/settings",
  "Agregar un atributo de dependencia": "/settings",
  "Modificar un atributo de dependencia": "/settings",
  "Eliminar un atributo de dependencia": "/settings",
 
  // Gestión de usuarios y roles
  "Crear un usuario": "/user-management",
  "Agregar un usuario": "/user-management",
  "Modificar datos del usuario": "/user-management",
  "Eliminar usuarios": "/user-management",
  "Ver la actividad de un usuario": "/user-management",
  "Reestablecer la contraseña de un Usuario": "/user-management",
  "Reestablecer la clave de un Usuario": "/user-management",
  "Ver usuarios eliminados": "/user-management",
  "Descargar listado de usuarios": "/user-management",
  "Crear roles": "/user-management",
  "Agregar roles": "/user-management",
  "Cambiar roles": "/user-management",
  "Modificar roles": "/user-management",
  "Eliminar roles": "/user-management",
  "Ver roles borrados": "/user-management",
  "Ver roles eliminados": "/user-management",
  "Descargar listado de roles": "/user-management",

  // Licencia
  "Ver datos de mi empresa": "/licences",
  "Actualizar datos de contacto de mi licencia": "/licences",
  "Ver datos de contacto de mi licencia": "/licences",
  "Ver licencia contratada": "/licences",
  "Ver el estado de mi licencia": "/licences",
  "Ver cantidad de usuarios de mi licencia": "/licences",
  "Ver cantidad de activos de mi licencia": "/licences",
  "Consultar fecha de alta de mi licencia": "/licences",
  "Consultar fecha de vencimiento de mi licencia": "/licences",

  // Dashboard
  "Dashboard": "/dashboard",
  "Ver dashboard": "/dashboard",
  "Consultar dashboard": "/dashboard",
  "Análisis general": "/dashboard",

  // Activos
  "Crear activos": "/assets",
  "Nuevo activo": "/assets",
  "Ver activos": "/assets",
  "Lista de activos": "/assets",
  "Editar activo": "/assets",
  "Modificar activo": "/assets",
  "Eliminar activo": "/assets",
  "Descargar listado de activos": "/assets",

  // Dependencias
  "Crear dependencia": "/dependencies",
  "Nueva dependencia": "/dependencies",
  "Ver dependencias": "/dependencies",
  "Lista de dependencias": "/dependencies",
  "Editar dependencia": "/dependencies",
  "Modificar dependencia": "/dependencies",
  "Eliminar dependencia": "/dependencies",
  "Descargar listado de dependencias": "/dependencies",
 
  // Controles
  "Crear control": "/controls",
  "Nuevo control": "/controls",
  "Ver controles": "/controls",
  "Lista de controles": "/controls",
  "Editar control": "/controls",
  "Modificar control": "/controls",
  "Eliminar control": "/controls",
  "Descargar listado de Controles": "/controls",
 
  // Asignaciones
  "Asignar controles a activos": "/assignment",
  "Asignar activos a controles": "/assignment",
  "Vincular control a activo": "/assignment",
  "Vincular activo a control": "/assignment",
  "Desasignar controles a activos": "/assignment",
  "Desasignar activos a controles": "/assignment",

  // Evaluaciones
  "Evaluar controles": "/evaluation",
  "Definir el estado de un control": "/evaluation",
  "Definir tipo de ejecución y frecuencia de un control": "/evaluation",
  "Establecer un control como diseñado": "/evaluation",
  "Establecer un control como implementado": "/evaluation",
  "Establecer un control como validado": "/evaluation",
  "Establecer un control como documentado": "/evaluation",
  "Agregar la documentación de un control": "/evaluation",
  "Descargar listado de evaluaciones de control": "/evaluation",

  // Gaps
  "Gaps": "/gaps",
  "Ver gaps": "/gaps",
  "Consultar gaps": "/gaps",
  "Ver gaps vencidos": "/gaps",
  "Ver gaps borrados": "/gaps",
  "Descargar listado de gaps": "/gaps",
 
  // Tareas
  "Tareas": "/tasks",
  "Ver tareas": "/tasks",
  "Consultar tareas": "/tasks",
  "Ver tareas delegadas": "/tasks",
  "Ver tareas asignadas": "/tasks",
  "Descargar listado de tareas": "/tasks",  

  // Procesos
  "Procesos": "/processes",
  "Crear proceso": "/processes",
  "Ver procesos": "/processes",
  "Editar proceso": "/processes",
  "Eliminar proceso": "/processes",
  "Descargar listado de procesos": "/processes",
};

const SearchBar = () => {
  const [searchTerm, setSearchTerm] = useState("");
  const navigate = useNavigate();

  const options = useMemo(() => {
    if (!searchTerm.trim()) return [];
    return Object.keys(searchRoutes)
      .filter((key) => key.toLowerCase().includes(searchTerm.toLowerCase().trim()))
      .map((key) => ({ value: key }));
  }, [searchTerm]);

  const handleSelect = (value) => {
    navigate(searchRoutes[value]);
    setSearchTerm(""); 
  };

  return (
    <AutoComplete
      options={options}
      value={searchTerm}
      onSearch={setSearchTerm}
      onSelect={handleSelect}
      placeholder="Encuentra lo que buscas"
      style={{ width: "100%" }}
    >
      <Input
        className="search-bar-input"
        suffix={
          <div className="search-bar-icon">
            <SearchOutlined />
          </div>
        }
        onPressEnter={() => handleSelect(searchTerm)}
      />
    </AutoComplete>
  );
};

export default SearchBar;
